import { Paging } from 'api/inc-api.types';
import { SingleTransaction } from '../transactions.types';

type TransactionsType = {
  content: SingleTransaction[];
  paging: Paging;
};

export const transactions: TransactionsType = {
  content: [
    {
      transactionId: 'ch_3M4gXbKdZ3YHmMQb1r777RNY',
      clientId: 'd2776d2a-33ae-4f3b-8091-34cad2e69fdc',
      locationId: '5d69f9ee-5628-4b64-98f7-685e425d63a1',
      createdDate: '2022-11-16T08:00:16Z',
      items: [
        {
          orderItemId: '63749845e4b05ec362e3af51',
          itemId: '63325578e4b02d805c242834',
          itemName: 'Import - APPLE PIE',
          displayInfoTitle: 'Apple Pie',
          group: {
            groupId: '63325804e4b02d805c242835',
            groupType: 'CATALOG_GROUP',
            groupName: 'Desserts',
            privateAttributes: {},
          },
          catalogId: '633258afe4b02d805c242836',
          unitPrice: 2490,
          quantity: 1,
          additionalAttributes: { recommendation_status: 'PRE' },
          externalId: 'externalId',
          itemInstructions: '',
          displayInfo: {
            langCode: 'EN',
            title: 'Apple Pie',
            shortDescription:
              'Flakey crust on the outside, cinnamon apple filling on the inside, \u0026  heavily dusted with powdered sugar.',
            smallImage: [],
            mediumImage: [],
          },
          privateAttributes: { DISPLAY_RANK: '1' },
          isTaxable: true,
          originalIsTaxable: true,
          taxes: [],
          itemTotal: {
            preDiscountSubtotal: 2490,
            appliedDiscount: 0,
            subtotal: 2490,
            total: 2490,
          },
          displayRank: 1,
          outOfOrder: false,
        },
      ],
      userId: 'GUEST',
      orderTotal: {
        preDiscountSubtotal: 2490,
        taxSummary: { totalTaxes: 0, taxes: [] },
        chargeSummary: {
          taxableCharges: 0,
          nonTaxableCharges: 0,
          bigTaxableCharges: 0,
          bigNonTaxableCharges: 0,
          charges: [],
        },
        totalDiscountApplied: 0,
        subtotal: 2490,
        gratuity: 750,
        total: 3240,
      },
      chargeAmount: 3240,
      applicationFee: 150,
      orderId: '63749841e4b05ec362e3af50',
      currency: 'usd',
      paymentMethod: {
        paymentMethodId: 'pm_1M4gXOKdZ3YHmMQbR3hgk2E9',
        type: 'card',
        cardBrand: 'visa',
        lastFour: '1111',
        expirationMonth: 11,
        expirationYear: 2023,
      },
      paymentIntentId: 'pi_3M4gXbKdZ3YHmMQb1P5dmsSf',
      stripeReceiptUrl:
        'https://pay.stripe.com/receipts/payment/CAcaFwoVYWNjdF8xSjNQTGFLZFozWUhtTVFiKJGx0psGMgaPwF9Kz1g6LBa3_BuSgrq9WseLc84xwRy8MSl7k4HHA80nCfYVSXhr2nrabOWtWE8ba-50',
      stripeAccountId: 'acct_1LmKQpQKILVC4wUm',
      status: 'SUCCEEDED',
      type: 'ORDER',
      paymentFailures: [],
    },
    {
      transactionId: 'ch_3M5Cm5KdZ3YHmMQb1vL5chbx',
      clientId: 'd2776d2a-33ae-4f3b-8091-34cad2e69fdc',
      locationId: '5d69f9ee-5628-4b64-98f7-685e425d63a1',
      createdDate: '2022-11-17T18:25:22Z',
      items: [
        {
          orderItemId: '63767c86e4b07f3e2b47aff9',
          itemId: '63325578e4b02d805c242834',
          itemName: 'Import - APPLE PIE',
          displayInfoTitle: 'Apple Pie',
          group: {
            groupId: '63325804e4b02d805c242835',
            groupType: 'CATALOG_GROUP',
            groupName: 'Desserts',
            privateAttributes: {},
          },
          catalogId: '633258afe4b02d805c242836',
          unitPrice: 2490,
          quantity: 1,
          additionalAttributes: { recommendation_status: 'PRE' },
          externalId: 'externalId',
          itemInstructions: '',
          displayInfo: {
            langCode: 'EN',
            title: 'Apple Pie',
            shortDescription:
              'Flakey crust on the outside, cinnamon apple filling on the inside, \u0026  heavily dusted with powdered sugar.',
            smallImage: [],
            mediumImage: [],
          },
          privateAttributes: { DISPLAY_RANK: '1' },
          isTaxable: true,
          originalIsTaxable: true,
          taxes: [],
          itemTotal: {
            preDiscountSubtotal: 2490,
            appliedDiscount: 0,
            subtotal: 2490,
            total: 2490,
          },
          displayRank: 1,
          outOfOrder: false,
        },
      ],
      userId: 'GUEST',
      customer: {
        firstName: 'Robert',
        lastName: 'McCracken',
        email: 'bobm@incentivio.com',
        phoneNumber: 5855764514,
      },
      orderTotal: {
        preDiscountSubtotal: 2490,
        taxSummary: { totalTaxes: 0, taxes: [] },
        chargeSummary: {
          taxableCharges: 0,
          nonTaxableCharges: 0,
          bigTaxableCharges: 0,
          bigNonTaxableCharges: 0,
          charges: [],
        },
        totalDiscountApplied: 0,
        subtotal: 2490,
        gratuity: 750,
        total: 3240,
      },
      chargeAmount: 3240,
      applicationFee: 150,
      orderId: '63767c80e4b07f3e2b47aff8',
      currency: 'usd',
      paymentMethod: {
        paymentMethodId: 'pm_1M5Cm4KdZ3YHmMQbewIgqFhb',
        billingName: 'Robert McCracken',
        type: 'card',
        cardBrand: 'visa',
        lastFour: '2002',
        expirationMonth: 4,
        expirationYear: 2024,
        walletType: 'google_pay',
      },
      paymentIntentId: 'pi_3M5Cm5KdZ3YHmMQb1S59cXyC',
      stripeReceiptUrl:
        'https://pay.stripe.com/receipts/payment/CAcaFwoVYWNjdF8xSjNQTGFLZFozWUhtTVFiKJP52ZsGMgasyQopLx46LBaPbQlggO--AbepUXE2WtZxfrYPcLBsRePg68qrZqTyDi3rzlg2NgoRi-au',
      stripeAccountId: 'acct_1LmKQpQKILVC4wUm',
      status: 'SUCCEEDED',
      type: 'ORDER',
      paymentFailures: [],
    },
    {
      transactionId: 'ch_3M5DZYKdZ3YHmMQb1EmtFulQ',
      clientId: 'd2776d2a-33ae-4f3b-8091-34cad2e69fdc',
      locationId: '5d69f9ee-5628-4b64-98f7-685e425d63a1',
      createdDate: '2022-11-17T19:16:29Z',
      items: [
        {
          orderItemId: '6376886fe4b07f3e2b47b010',
          itemId: '63325578e4b02d805c242834',
          itemName: 'Import - APPLE PIE',
          displayInfoTitle: 'Apple Pie',
          group: {
            groupId: '63325804e4b02d805c242835',
            groupType: 'CATALOG_GROUP',
            groupName: 'Desserts',
            privateAttributes: {},
          },
          catalogId: '633258afe4b02d805c242836',
          unitPrice: 2490,
          quantity: 1,
          additionalAttributes: { recommendation_status: 'PRE' },
          externalId: 'externalId',
          itemInstructions: '',
          displayInfo: {
            langCode: 'EN',
            title: 'Apple Pie',
            shortDescription:
              'Flakey crust on the outside, cinnamon apple filling on the inside, \u0026  heavily dusted with powdered sugar.',
            smallImage: [],
            mediumImage: [],
          },
          privateAttributes: { DISPLAY_RANK: '1' },
          isTaxable: true,
          originalIsTaxable: true,
          taxes: [],
          itemTotal: {
            preDiscountSubtotal: 2490,
            appliedDiscount: 0,
            subtotal: 2490,
            total: 2490,
          },
          displayRank: 1,
          outOfOrder: false,
        },
      ],
      userId: 'GUEST',
      customer: {
        firstName: 'Robert',
        lastName: 'McCracken',
        email: 'bobm@incentivio.com',
        phoneNumber: 5855764514,
      },
      orderTotal: {
        preDiscountSubtotal: 2490,
        taxSummary: { totalTaxes: 0, taxes: [] },
        chargeSummary: {
          taxableCharges: 0,
          nonTaxableCharges: 0,
          bigTaxableCharges: 0,
          bigNonTaxableCharges: 0,
          charges: [],
        },
        totalDiscountApplied: 0,
        subtotal: 2490,
        gratuity: 750,
        total: 3240,
      },
      chargeAmount: 3240,
      applicationFee: 150,
      orderId: '6376886ce4b07f3e2b47b00f',
      currency: 'usd',
      paymentMethod: {
        paymentMethodId: 'pm_1M5DZYKdZ3YHmMQbrNHuIS4R',
        billingName: 'Robert McCracken',
        type: 'card',
        cardBrand: 'visa',
        lastFour: '2002',
        expirationMonth: 4,
        expirationYear: 2024,
        walletType: 'google_pay',
      },
      paymentIntentId: 'pi_3M5DZYKdZ3YHmMQb1L4OQA2h',
      stripeReceiptUrl:
        'https://pay.stripe.com/receipts/payment/CAcaFwoVYWNjdF8xSjNQTGFLZFozWUhtTVFiKI6R2psGMgY0UM1MXls6LBauoRnvXE84RcnX9jaDYo6YPHGXASmYyIQiDl4_-ODryATLXYjvLG-phodz',
      stripeAccountId: 'acct_1LmKQpQKILVC4wUm',
      status: 'SUCCEEDED',
      type: 'ORDER',
      paymentFailures: [],
    },
    {
      transactionId: 'ch_3M5DctKdZ3YHmMQb0owsctWL',
      clientId: 'd2776d2a-33ae-4f3b-8091-34cad2e69fdc',
      locationId: '5d69f9ee-5628-4b64-98f7-685e425d63a1',
      createdDate: '2022-11-17T19:19:57Z',
      items: [
        {
          orderItemId: '63768927e4b07f3e2b47b01d',
          itemId: '63325578e4b02d805c242834',
          itemName: 'Import - APPLE PIE',
          displayInfoTitle: 'Apple Pie',
          group: {
            groupId: '63325804e4b02d805c242835',
            groupType: 'CATALOG_GROUP',
            groupName: 'Desserts',
            privateAttributes: {},
          },
          catalogId: '633258afe4b02d805c242836',
          unitPrice: 2490,
          quantity: 1,
          additionalAttributes: { recommendation_status: 'PRE' },
          externalId: 'externalId',
          itemInstructions: '',
          displayInfo: {
            langCode: 'EN',
            title: 'Apple Pie',
            shortDescription:
              'Flakey crust on the outside, cinnamon apple filling on the inside, \u0026  heavily dusted with powdered sugar.',
            smallImage: [],
            mediumImage: [],
          },
          privateAttributes: { DISPLAY_RANK: '1' },
          isTaxable: true,
          originalIsTaxable: true,
          taxes: [],
          itemTotal: {
            preDiscountSubtotal: 2490,
            appliedDiscount: 0,
            subtotal: 2490,
            total: 2490,
          },
          displayRank: 1,
          outOfOrder: false,
        },
      ],
      userId: 'GUEST',
      orderTotal: {
        preDiscountSubtotal: 2490,
        taxSummary: { totalTaxes: 0, taxes: [] },
        chargeSummary: {
          taxableCharges: 0,
          nonTaxableCharges: 0,
          bigTaxableCharges: 0,
          bigNonTaxableCharges: 0,
          charges: [],
        },
        totalDiscountApplied: 0,
        subtotal: 2490,
        gratuity: 750,
        total: 3240,
      },
      chargeAmount: 3240,
      applicationFee: 150,
      orderId: '637688fee4b07f3e2b47b01c',
      currency: 'usd',
      paymentMethod: {
        paymentMethodId: 'pm_1M5DcuKdZ3YHmMQb0TLGknbM',
        billingZip: '55555',
        type: 'card',
        cardBrand: 'visa',
        lastFour: '4242',
        expirationMonth: 5,
        expirationYear: 2055,
      },
      paymentIntentId: 'pi_3M5DctKdZ3YHmMQb0Nnn0IPw',
      stripeReceiptUrl:
        'https://pay.stripe.com/receipts/payment/CAcaFwoVYWNjdF8xSjNQTGFLZFozWUhtTVFiKN2S2psGMgao0wfedyo6LBYulb3WCK7t6v94bc75bRbWr3NzMUpjSnl7KV2qSRtJCRwLCLZgiRI-2UPi',
      stripeAccountId: 'acct_1LmKQpQKILVC4wUm',
      status: 'SUCCEEDED',
      type: 'ORDER',
      paymentFailures: [],
    },
    {
      transactionId: 'ch_3M5DeZKdZ3YHmMQb167Ut3ew',
      clientId: 'd2776d2a-33ae-4f3b-8091-34cad2e69fdc',
      locationId: '5d69f9ee-5628-4b64-98f7-685e425d63a1',
      createdDate: '2022-11-17T19:21:40Z',
      items: [
        {
          orderItemId: '637689b4e4b07f3e2b47b02a',
          itemId: '63325578e4b02d805c242834',
          itemName: 'Import - APPLE PIE',
          displayInfoTitle: 'Apple Pie',
          group: {
            groupId: '63325804e4b02d805c242835',
            groupType: 'CATALOG_GROUP',
            groupName: 'Desserts',
            privateAttributes: {},
          },
          catalogId: '633258afe4b02d805c242836',
          unitPrice: 2490,
          quantity: 1,
          additionalAttributes: { recommendation_status: 'PRE' },
          externalId: 'externalId',
          itemInstructions: '',
          displayInfo: {
            langCode: 'EN',
            title: 'Apple Pie',
            shortDescription:
              'Flakey crust on the outside, cinnamon apple filling on the inside, \u0026  heavily dusted with powdered sugar.',
            smallImage: [],
            mediumImage: [],
          },
          privateAttributes: { DISPLAY_RANK: '1' },
          isTaxable: true,
          originalIsTaxable: true,
          taxes: [],
          itemTotal: {
            preDiscountSubtotal: 2490,
            appliedDiscount: 0,
            subtotal: 2490,
            total: 2490,
          },
          displayRank: 1,
          outOfOrder: false,
        },
      ],
      userId: 'GUEST',
      customer: {
        firstName: 'Robert',
        lastName: 'McCracken',
        email: 'bobm@incentivio.com',
        phoneNumber: 5855764514,
      },
      orderTotal: {
        preDiscountSubtotal: 2490,
        taxSummary: { totalTaxes: 0, taxes: [] },
        chargeSummary: {
          taxableCharges: 0,
          nonTaxableCharges: 0,
          bigTaxableCharges: 0,
          bigNonTaxableCharges: 0,
          charges: [],
        },
        totalDiscountApplied: 0,
        subtotal: 2490,
        gratuity: 750,
        total: 3240,
      },
      chargeAmount: 3240,
      applicationFee: 150,
      orderId: '637689b2e4b07f3e2b47b029',
      currency: 'usd',
      paymentMethod: {
        paymentMethodId: 'pm_1M5DeYKdZ3YHmMQbOqLTPByS',
        billingName: 'Robert McCracken',
        type: 'card',
        cardBrand: 'visa',
        lastFour: '2002',
        expirationMonth: 4,
        expirationYear: 2024,
        walletType: 'google_pay',
      },
      paymentIntentId: 'pi_3M5DeZKdZ3YHmMQb1lrcVRyH',
      stripeReceiptUrl:
        'https://pay.stripe.com/receipts/payment/CAcaFwoVYWNjdF8xSjNQTGFLZFozWUhtTVFiKMWT2psGMgYf7apXm-k6LBaTVtpZ2rDmdLnXDcX7d2oEdTlXauBt3YCEKLdLOgxpuO_gYNOY9yILFC9C',
      stripeAccountId: 'acct_1LmKQpQKILVC4wUm',
      status: 'SUCCEEDED',
      type: 'ORDER',
      paymentFailures: [],
    },
    {
      transactionId: 'ch_3M5Di6KdZ3YHmMQb0aQqb1Im',
      clientId: 'd2776d2a-33ae-4f3b-8091-34cad2e69fdc',
      locationId: '5d69f9ee-5628-4b64-98f7-685e425d63a1',
      createdDate: '2022-11-17T19:25:19Z',
      items: [
        {
          orderItemId: '637689f0e4b07f3e2b47b037',
          itemId: '63325578e4b02d805c242834',
          itemName: 'Import - APPLE PIE',
          displayInfoTitle: 'Apple Pie',
          group: {
            groupId: '63325804e4b02d805c242835',
            groupType: 'CATALOG_GROUP',
            groupName: 'Desserts',
            privateAttributes: {},
          },
          catalogId: '633258afe4b02d805c242836',
          unitPrice: 2490,
          quantity: 1,
          additionalAttributes: { recommendation_status: 'PRE' },
          externalId: 'externalId',
          itemInstructions: '',
          displayInfo: {
            langCode: 'EN',
            title: 'Apple Pie',
            shortDescription:
              'Flakey crust on the outside, cinnamon apple filling on the inside, \u0026  heavily dusted with powdered sugar.',
            smallImage: [],
            mediumImage: [],
          },
          privateAttributes: { DISPLAY_RANK: '1' },
          isTaxable: true,
          originalIsTaxable: true,
          taxes: [],
          itemTotal: {
            preDiscountSubtotal: 2490,
            appliedDiscount: 0,
            subtotal: 2490,
            total: 2490,
          },
          displayRank: 1,
          outOfOrder: false,
        },
      ],
      userId: 'GUEST',
      orderTotal: {
        preDiscountSubtotal: 2490,
        taxSummary: { totalTaxes: 0, taxes: [] },
        chargeSummary: {
          taxableCharges: 0,
          nonTaxableCharges: 0,
          bigTaxableCharges: 0,
          bigNonTaxableCharges: 0,
          charges: [],
        },
        totalDiscountApplied: 0,
        subtotal: 2490,
        gratuity: 0,
        total: 2490,
      },
      chargeAmount: 3240,
      applicationFee: 150,
      orderId: '637689ede4b07f3e2b47b036',
      currency: 'usd',
      paymentMethod: {
        paymentMethodId: 'pm_1M5DhAKdZ3YHmMQbg3scRkMZ',
        billingZip: '55555',
        type: 'card',
        cardBrand: 'visa',
        lastFour: '0341',
        expirationMonth: 5,
        expirationYear: 2055,
      },
      paymentIntentId: 'pi_3M5Di6KdZ3YHmMQb0eHKTrIV',
      stripeAccountId: 'acct_1LmKQpQKILVC4wUm',
      status: 'FAILED',
      type: 'ORDER',
      paymentFailures: [
        {
          failureCode: 'card_declined',
          failureMessage: 'Your card was declined.',
          createdTimestamp: '2022-11-17T19:25:20.551Z',
        },
      ],
    },
    {
      transactionId: 'ch_3M5DiiKdZ3YHmMQb1vy8NTFA',
      clientId: 'd2776d2a-33ae-4f3b-8091-34cad2e69fdc',
      locationId: '5d69f9ee-5628-4b64-98f7-685e425d63a1',
      createdDate: '2022-11-17T19:25:57Z',
      items: [
        {
          orderItemId: '637689f0e4b07f3e2b47b037',
          itemId: '63325578e4b02d805c242834',
          itemName: 'Import - APPLE PIE',
          displayInfoTitle: 'Apple Pie',
          group: {
            groupId: '63325804e4b02d805c242835',
            groupType: 'CATALOG_GROUP',
            groupName: 'Desserts',
            privateAttributes: {},
          },
          catalogId: '633258afe4b02d805c242836',
          unitPrice: 2490,
          quantity: 1,
          additionalAttributes: { recommendation_status: 'PRE' },
          externalId: 'externalId',
          itemInstructions: '',
          displayInfo: {
            langCode: 'EN',
            title: 'Apple Pie',
            shortDescription:
              'Flakey crust on the outside, cinnamon apple filling on the inside, \u0026  heavily dusted with powdered sugar.',
            smallImage: [],
            mediumImage: [],
          },
          privateAttributes: { DISPLAY_RANK: '1' },
          isTaxable: true,
          originalIsTaxable: true,
          taxes: [],
          itemTotal: {
            preDiscountSubtotal: 2490,
            appliedDiscount: 0,
            subtotal: 2490,
            total: 2490,
          },
          displayRank: 1,
          outOfOrder: false,
        },
      ],
      userId: 'GUEST',
      orderTotal: {
        preDiscountSubtotal: 2490,
        taxSummary: { totalTaxes: 0, taxes: [] },
        chargeSummary: {
          taxableCharges: 0,
          nonTaxableCharges: 0,
          bigTaxableCharges: 0,
          bigNonTaxableCharges: 0,
          charges: [],
        },
        totalDiscountApplied: 0,
        subtotal: 2490,
        gratuity: 1490,
        total: 3980,
      },
      chargeAmount: 3980,
      applicationFee: 150,
      orderId: '637689ede4b07f3e2b47b036',
      currency: 'usd',
      paymentMethod: {
        paymentMethodId: 'pm_1M5DgMKdZ3YHmMQbmQgczSZm',
        billingZip: '55555',
        type: 'card',
        cardBrand: 'mastercard',
        lastFour: '4444',
        expirationMonth: 5,
        expirationYear: 2055,
      },
      paymentIntentId: 'pi_3M5DiiKdZ3YHmMQb13fPr6Q0',
      stripeReceiptUrl:
        'https://pay.stripe.com/receipts/payment/CAcaFwoVYWNjdF8xSjNQTGFLZFozWUhtTVFiKMaV2psGMgaunL4dpok6LBaztjeekT-KGZQzHrQtKs9Kq7Ew45LMNMJJibe-Xuu31t7GXkfIrve4P-sG',
      stripeAccountId: 'acct_1LmKQpQKILVC4wUm',
      status: 'REFUNDED',
      type: 'ORDER',
      paymentFailures: [],
    },
    {
      transactionId: 'ch_3M5DmsKdZ3YHmMQb16dU1IkE',
      clientId: 'd2776d2a-33ae-4f3b-8091-34cad2e69fdc',
      locationId: '5d69f9ee-5628-4b64-98f7-685e425d63a1',
      createdDate: '2022-11-17T19:30:15Z',
      items: [
        {
          orderItemId: '63768ba5e4b07f3e2b47b04f',
          itemId: '63325578e4b02d805c242834',
          itemName: 'Import - APPLE PIE',
          displayInfoTitle: 'Apple Pie',
          group: {
            groupId: '63325804e4b02d805c242835',
            groupType: 'CATALOG_GROUP',
            groupName: 'Desserts',
            privateAttributes: {},
          },
          catalogId: '633258afe4b02d805c242836',
          unitPrice: 2490,
          quantity: 3,
          additionalAttributes: { recommendation_status: 'PRE' },
          externalId: 'externalId',
          itemInstructions: '',
          displayInfo: {
            langCode: 'EN',
            title: 'Apple Pie',
            shortDescription:
              'Flakey crust on the outside, cinnamon apple filling on the inside, \u0026  heavily dusted with powdered sugar.',
            smallImage: [],
            mediumImage: [],
          },
          privateAttributes: { DISPLAY_RANK: '1' },
          isTaxable: true,
          originalIsTaxable: true,
          taxes: [],
          itemTotal: {
            preDiscountSubtotal: 7470,
            appliedDiscount: 0,
            subtotal: 7470,
            total: 7470,
          },
          displayRank: 1,
          outOfOrder: false,
        },
      ],
      userId: 'GUEST',
      customer: {
        firstName: 'Robert',
        lastName: 'McCracken',
        email: 'bobm@incentivio.com',
        phoneNumber: 5855764514,
      },
      orderTotal: {
        preDiscountSubtotal: 7470,
        taxSummary: { totalTaxes: 0, taxes: [] },
        chargeSummary: {
          taxableCharges: 0,
          nonTaxableCharges: 0,
          bigTaxableCharges: 0,
          bigNonTaxableCharges: 0,
          charges: [],
        },
        totalDiscountApplied: 0,
        subtotal: 7470,
        gratuity: 1490,
        total: 8960,
      },
      chargeAmount: 8960,
      applicationFee: 150,
      orderId: '63768ba3e4b07f3e2b47b04e',
      currency: 'usd',
      paymentMethod: {
        paymentMethodId: 'pm_1M5DmsKdZ3YHmMQbM4IUDSLQ',
        billingName: 'Robert McCracken',
        type: 'card',
        cardBrand: 'visa',
        lastFour: '2002',
        expirationMonth: 4,
        expirationYear: 2024,
        walletType: 'google_pay',
      },
      paymentIntentId: 'pi_3M5DmsKdZ3YHmMQb1PG10pt6',
      stripeReceiptUrl:
        'https://pay.stripe.com/receipts/payment/CAcaFwoVYWNjdF8xSjNQTGFLZFozWUhtTVFiKMiX2psGMgb4tnFaOmY6LBYdXxotZ-hWpDpPk3NgUmT6buJxIqm_5q8mU9qamx-CoY84L8Y9zcyhbfBU',
      stripeAccountId: 'acct_1LmKQpQKILVC4wUm',
      status: 'REFUND_FAILED',
      type: 'ORDER',
      paymentFailures: [],
    },
    {
      transactionId: 'ch_3M5DpOKdZ3YHmMQb1XVBFks8',
      clientId: 'd2776d2a-33ae-4f3b-8091-34cad2e69fdc',
      locationId: '5d69f9ee-5628-4b64-98f7-685e425d63a1',
      createdDate: '2022-11-17T19:32:51Z',
      items: [
        {
          orderItemId: '63768c56e4b07f3e2b47b05e',
          itemId: '63325578e4b02d805c242834',
          itemName: 'Import - APPLE PIE',
          displayInfoTitle: 'Apple Pie',
          group: {
            groupId: '63325804e4b02d805c242835',
            groupType: 'CATALOG_GROUP',
            groupName: 'Desserts',
            privateAttributes: {},
          },
          catalogId: '633258afe4b02d805c242836',
          unitPrice: 2490,
          quantity: 1,
          additionalAttributes: { recommendation_status: 'PRE' },
          externalId: 'externalId',
          itemInstructions: '',
          displayInfo: {
            langCode: 'EN',
            title: 'Apple Pie',
            shortDescription:
              'Flakey crust on the outside, cinnamon apple filling on the inside, \u0026  heavily dusted with powdered sugar.',
            smallImage: [],
            mediumImage: [],
          },
          privateAttributes: { DISPLAY_RANK: '1' },
          isTaxable: true,
          originalIsTaxable: true,
          taxes: [],
          itemTotal: {
            preDiscountSubtotal: 2490,
            appliedDiscount: 0,
            subtotal: 2490,
            total: 2490,
          },
          displayRank: 1,
          outOfOrder: false,
        },
      ],
      userId: 'GUEST',
      customer: {
        firstName: 'Robert',
        lastName: 'McCracken',
        email: 'bobm@incentivio.com',
        phoneNumber: 5855764514,
      },
      orderTotal: {
        preDiscountSubtotal: 2490,
        taxSummary: { totalTaxes: 0, taxes: [] },
        chargeSummary: {
          taxableCharges: 0,
          nonTaxableCharges: 0,
          bigTaxableCharges: 0,
          bigNonTaxableCharges: 0,
          charges: [],
        },
        totalDiscountApplied: 0,
        subtotal: 2490,
        gratuity: 750,
        total: 3240,
      },
      chargeAmount: 3240,
      applicationFee: 200,
      orderId: '63768c53e4b07f3e2b47b05d',
      currency: 'usd',
      paymentMethod: {
        paymentMethodId: 'pm_1M5DpNKdZ3YHmMQbWhaOC9Gx',
        billingName: 'Robert McCracken',
        type: 'card',
        cardBrand: 'visa',
        lastFour: '2002',
        expirationMonth: 4,
        expirationYear: 2024,
        walletType: 'google_pay',
      },
      paymentIntentId: 'pi_3M5DpOKdZ3YHmMQb1pkfGw1S',
      stripeReceiptUrl:
        'https://pay.stripe.com/receipts/payment/CAcaFwoVYWNjdF8xSjNQTGFLZFozWUhtTVFiKOSY2psGMgb0mQlRwtI6LBa6nx5U5GREPS4iIMekp39zivMUEDHKDtIacJAk9vYNAfkNd5jChH4tsDY9',
      stripeAccountId: 'acct_1LmKQpQKILVC4wUm',
      status: 'REFUND_PENDING',
      type: 'ORDER',
      paymentFailures: [],
    },
    {
      transactionId: 'ch_3OCJKYKdZ3YHmMQb1RwPr3AX',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      locationId: '952e1839-75f2-4d4b-9949-3760579583b8',
      createdDate: '2023-11-14T09:54:51Z',
      userId: 'ebe8dbcd-d7b7-4bbb-8666-1db329ab8a98',
      stripeCustomerId: 'cus_OyPkQIUOWroOxk',
      chargeAmount: 4980,
      applicationFee: 240,
      scanToPayTxId: '56db4137-19f4-4e00-ab80-af566f9200a6',
      currency: 'usd',
      paymentMethod: {
        paymentMethodId: 'pm_1OATENKdZ3YHmMQb46HaxIjL',
        billingZip: '12345',
        type: 'card',
        cardBrand: 'visa',
        lastFour: '1111',
        expirationMonth: 11,
        expirationYear: 2024,
      },
      paymentIntentId: 'pi_3OCJKYKdZ3YHmMQb1SLTPz7Q',
      statementDescriptor: 'PALMLANEDEV',
      stripeReceiptUrl:
        'https://pay.stripe.com/receipts/payment/CAcaFwoVYWNjdF8xSjNQTGFLZFozWUhtTVFiKOuHzaoGMgaQwiaW8hc6LBY4id1nYWuSejhamD0eh151KlfJ5xlDx6x74n_ATuc1EqDGebnYliLo4Ayg',
      stripeAccountId: 'acct_1NckehQKpc45sl2h',
      status: 'PARTIALLY_REFUNDED',
      type: 'SCAN_TO_PAY',
      refunds: [
        {
          refundId: 're_3OCJKYKdZ3YHmMQb1A7tCh3X',
          refundAmount: 4980,
          createdDate: '2023-11-14T10:16:04Z',
        },
      ],
      paymentFailures: [],
      events: [
        {
          eventId: 'evt_3OCJKYKdZ3YHmMQb1tQWA6gT',
          type: 'PAYMENT_SUCCESS',
          createdDate: '2023-11-14T09:55:18.577Z',
        },
        {
          type: 'REFUND_SUCCESS',
          createdDate: '2023-11-14T10:16:05.951Z',
          refundDetails: {
            refundId: 're_3OCJKYKdZ3YHmMQb1A7tCh3X',
            refundAmount: 4980,
            createdDate: '2023-11-14T10:16:04Z',
          },
        },
      ],
    },
  ],
  paging: { total: 11, count: 10, totalPages: 2, currentPage: 0 },
};
